import { httpGet, httpPut, httpPost, httpDownload } from '../../../util/request.js';
import appConfig from "@/config";

export default class BudgetTypeApi {
	static list(param) {
		return this.httpRequest('list', param, 'get');
	}

	static importData(file) {
		let formData = new FormData()
		formData.append('file', file);
		return this.httpRequest('importData', formData, 'post');
	}

	static importTemplate(param) {
		return this.httpRequest('importTemplate', param, 'download');
	}

	static exportData(param) {
		return this.httpRequest('exportData', param, 'download');
	}

	static get(param) {
		return this.httpRequest('get', param, 'get');
	}

	static edit(param) {
		return this.httpRequest('edit', param, 'put');
	}

	static disable(param) {
		return this.httpRequest('disable', param, 'put');
	}

	static enable(param) {
		return this.httpRequest('enable', param, 'put');
	}

	static listSubject(){
		return this.httpRequest('subject', {}, 'get');
	}

	// static baseUrl = "http://localhost:20065/pd-service" + "/wb/pd-wb-budget-type/";
	static baseUrl = appConfig.gatewayUrl + appConfig.pdServicePath + "/wb/pd-wb-budget-type/";

	static httpRequest(url, param, method) {
		if (method == 'get') {
			return httpGet(this.baseUrl + url, param);
		}
		if (method == 'post') {
			return httpPost(this.baseUrl + url, param);
		}
		if (method == 'put') {
			return httpPut(this.baseUrl + url, param);
		}
		if (method == 'download') {
			return httpDownload(this.baseUrl + url, param);
		}
	}

	static handleResponse(response, scope, successFunc, errorFunc) {
		let data = response.data;
		if (data.code == 200) {
			if (successFunc && typeof successFunc == 'function') {
				successFunc(data.data);
			}
		} else {
			let text = data.errMsg
			scope.$dialog.error({
				text: text,
				title: "错误"
			});
			if (errorFunc && typeof errorFunc == 'function') {
				errorFunc(data);
			}
		}
	}

	static handleNetworkError(response, scope, errorFunc) {
		scope.$dialog.error({
			text: response.message,
			title: "错误"
		});
		if (errorFunc && typeof errorFunc == 'function') {
			errorFunc(response);
		}
	}




}